/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { Outlet } from "react-router-dom";
import Footer from "../layout/footer";
import Header from "../layout/header";

export function UnProtectedContainer(): JSX.Element {

    return (
        <>
            <Header />
            <div className='Basecontainer'>
                <main className='Basemain'>
                    <Outlet />
                </main>
            </div>
            <Footer />
        </>
    )

} 